var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#108753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6b41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e02c42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d22036"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v4.571429h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.857143h16v4.571429h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 4.57142857h-6.85714286v2.28571429h6.85714286v4.57142854h2.28571428v-4.57142854h6.85714286v-2.28571429h-6.85714286v-4.57142857h-2.28571428z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.61904762 6.0952381v5.3333333h.76190476v-5.3333333h7.61904762v-.76190477h-7.61904762v-5.33333333h-.76190476v5.33333333h-7.61904762v.76190477z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 5.33333333v6.09523807h.76190476v-6.09523807h8.38095238v-.76190476h-8.38095238v-4.57142857h-.76190476v4.57142857h-6.85714286v.76190476z",
    fill: "url(#e)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.714286,
    fill: "url(#f)",
    mask: "url(#g)",
    r: 2.666667
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0e673f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 8c-.21039421 0-.38095238-.17055817-.38095238-.38095238 0-.21039419.17055817-.38095238.38095238-.38095238.20838286 0 .41026217-.04163477.59721486-.12137446.19352602-.08254335.41732442.00742586.49986773.20095186.08254339.19352599-.00742583.41732439-.20095185.49986778-.2810275.11986476-.58453821.18245958-.89613074.18245958zm2.1458915-1.49704002c.0869464-.23650902.1343575-.48690938.1393775-.74317294.0004546-.0910245-.0009828-.14556302-.0049378-.20339028-.014356-.20990383-.1961547-.3684266-.40605851-.35407053-.20990378.01435609-.36842659.19615466-.35407048.40605849.00258453.037789.00354598.07427229.00323893.14221965-.00328602.1655411-.0348336.33215862-.09266247.48946308-.07259581.19747296.02863718.41640692.22611009.48900268.19747299.07259577.41640694-.02863719.48900274-.22611015zm-.72351725-2.57799756c-.24054446-.19142644-.51748937-.33292421-.81528846-.41479403-.2028675-.05577161-.412536.06347323-.46830758.26634078s.06347322.41253601.26634072.46830761c.19802202.05443947.38239033.14863763.5428237.2763113.16462659.13101069.40428792.10375958.53529859-.06086701.13101074-.16462661.10375962-.40428797-.06086697-.53529865zm-2.6081569-.1650772c-.26270319.15967318-.4909606.37099721-.6704968.62047049-.1228962.17076955-.08408718.40883268.08668238.53172888.17076955.12289619.40883267.08408717.53172887-.08668239.11991928-.16663299.27247122-.30786779.44781398-.41444258.17978923-.10927739.23695037-.34361218.12767299-.52340142-.10927739-.17978922-.34361219-.23695038-.52340142-.12767298zm-1.05103608 2.42652674c.06364511.30279613.18806204.58771527.36452511.83926582.12082664.17224006.35840414.21391888.5306442.09309223.17224006-.12082663.21391887-.35840414.09309223-.5306442-.1175892-.16762504-.20033295-.35711114-.24264948-.55843502-.04327736-.20589509-.24527153-.3377228-.45116662-.29444544-.20589508.04327735-.3377228.24527153-.29444544.45116661zm1.93580166 1.79389981c-.20859107-.02748625-.3554055-.21886468-.32791923-.42745575.02748626-.20859104.21886472-.35540548.42745577-.32791921.0617075.00813127.12420259.01252113.1872816.01309399.21038552.0019106.37938788.17401061.37747725.3843961-.00191062.21038552-.17401059.37938788-.38439611.37747725-.09407528-.00085432-.18750004-.00741684-.27989928-.01959238z",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 6.47619048c.42078834 0 .38095238-.34111638.38095238-.76190477 0-.42078838.03983596-.76190476-.38095238-.76190476-.42078838 0-.38095238.34111638-.38095238.76190476 0 .42078839-.039836.76190477.38095238.76190477z",
    mask: "url(#g)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/DM.a85e6060597471601d1354c5b59e1ad0.svg";
export { ForwardRef as ReactComponent };